import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App/App";
import { BrowserRouter } from "react-router-dom";
import { PodologProvider } from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PodologProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </PodologProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
